<script>
export default {
    props: {
        periods: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        statusLabel(status) {
            const map = {
                0: this.$t("contract_detail.status_staged"),
                1: this.$t("contract_detail.status_calculated"),
                2: this.$t("contract_detail.status_invoiced")
            };
            return map[status] || "";
        },
        statusClass(status) {
            const map = {
                0: "text-muted",
                1: "text-warning",
                2: "text-success"
            };
            return map[status] || "";
        }
    }
};
</script>

<template>
    <div class="payment-periods d-flex flex-wrap">
        <div v-for="p in periods" :key="p.id" class="payment-period mr-2 mb-1">
            <div class="pp-dates">
                {{ $d(new Date(p.date_from)) }} &ndash;
                {{ $d(new Date(p.date_to)) }}
            </div>
            <div class="pp-fee">
                {{
                    $n(p.base_fee, {
                        currency: p.currency,
                        style: "currency",
                        currencyDisplay: "code"
                    })
                }}
            </div>
            <div class="pp-invoice-date">
                <i class="far fa-file-invoice-dollar"></i>
                {{ $d(new Date(p.invoicing_date)) }}
            </div>
            <div class="pp-status" :class="statusClass(p.status)">
                {{ statusLabel(p.status) }}
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.payment-periods {
    .payment-period {
        border: 1px solid $gray-300;
        border-radius: 6px;
        text-align: center;
        padding: 4px;
        font-size: 12px;
    }

    .pp-dates {
    }

    .pp-fee {
        margin-top: 3px;
        margin-bottom: 3px;
        font-weight: 600;
    }
}
</style>
